import {
	createServer,
	Model,
	Serializer
} from "miragejs";
import lookups from "./fixtures/lookup"
import campaigns from "./fixtures/campaigns"

let ApplicationSerializer = Serializer.extend({
	root: false,
	embed: true
});

export function makeServer({
	environment = "demo"
} = {}) {
	let server = createServer({
		serializers: {
			application: ApplicationSerializer
		},
		environment,
		models: {
			lookups: Model,
			campaigns: Model,
		},
		fixtures: {
			lookups,
			campaigns,
		},
		seeds(server) {
			server.loadFixtures();
		},
		routes() {
			this.namespace = process.env.VUE_APP_API_DOMAIN;
			this.passthrough('https://leadershipinstitute.us.auth0.com/oauth/token');

			this.get(process.env.VUE_APP_API_DOMAIN + "/lookup/getLookUpByCode/:typecode", (schema, request) => {
				let requestedLookups = schema.lookups.where({
					lookUpTypeCode: request.params.typecode
				});

				return requestedLookups;
			});

			// eslint-disable-next-line no-unused-vars
			this.post(process.env.VUE_APP_API_DOMAIN + "/search/getCampaignDataWithFilter/", (schema, request) => {
				return schema.campaigns.all().slice(0, 1000);
			});

		},
	});

	return server;
}
